import type { ButtonConfig } from '../../declare'
import { useContext } from 'react'
import { EasyIcon, ListTableContext } from 'src/components'

type Props = {
  config: ButtonConfig
}

const CustomRenderBtn = (props: Props) => {
  const table = useContext(ListTableContext)

  if (table?.dynamicJs[props.config.CLICK_EVENT] instanceof Function) {
    return table.dynamicJs[props.config.CLICK_EVENT](table, props)
  }

  const { LABEL, ICON } = props.config
  return (
    <span title={LABEL}>
      <EasyIcon type={ICON} defaultIcon='SettingOutlined' className='fz-16' />
      <span className='pd-l4'>{LABEL}</span>
    </span>
  )
}

export default CustomRenderBtn